import { api } from "./plpsApi";
import { plpsUtilsURL, plpsPlatformAgentsURL } from "../../constant";

/**
 * Converts a File to a base64 string
 */
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result;
      const base64 = result.split(",")[1];
      resolve(base64);
    };

    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

/**
 * PLPS Planner Trigger
 */
export const triggePLPSPlanner = async (payload, signal) => {
  try {
    const response = await api.post(`${plpsPlatformAgentsURL}/generate-response/run`, payload, { signal });
    return response.data.response;
  } catch (error) {
    if (axios.isCancel?.(error) || error.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.warn("PLPS Planner Generation request aborted");
      return; // exit silently
    }
    console.error("PLPS Planner Trigger failed:", error);
    throw error;
  }
};

/**
 * Upload PLPS File
 */
export const uploadPLPSFile = async (payload) => {
  try {
    const response = await api.post(`${plpsUtilsURL}/file-upload/run`, payload);
    return response.data.response;
  } catch (error) {
    console.error("PLPS File Upload failed:", error);
    throw error;
  }
};

/**
 * Digitize PLPS File
 */
export const digitizePLPSFile = async (payload, signal) => {
  try {
    const response = await api.post(`${plpsUtilsURL}/file-digitization/run`, payload, { signal });
    return response.data.response;
  } catch (error) {
    if (axios.isCancel?.(error) || error.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.warn("Digitization request aborted");
      return; // exit silently
    }
    console.error("PLPS File Digitization failed:", error);
    throw error;
  }
};

/**
 * Get PLPS Digitization Percentage
 */
export const getPLPSDigitizationPercent = async (payload) => {
  try {
    const response = await api.post(`${plpsUtilsURL}/digitization-percent/run`, payload);
    return response.data.response;
  } catch (error) {
    console.error("Get PLPS Digitization Percent failed:", error);
    throw error;
  }
};

/**
 * Get Template List
 */
export const getPLPSTemplateList = async () => {
  try {
    const response = await api.post(`${plpsUtilsURL}/get-template/run`);
    return response.data.response;
  } catch (error) {
    console.error("Get PLPS Template List failed:", error);
    throw error;
  }
};

/**
 * Get Template Section
 */
export const getPLPSTemplateSection = async (payload) => {
  try {
    const response = await api.post(`${plpsUtilsURL}/get-section-list/run`, payload);
    return response.data.response;
  } catch (error) {
    console.error("Get PLPS Template Section failed:", error);
    throw error;
  }
};

/**
 * Save Selected Section
 */
// export const savePLPSSelectedSection = async (payload) => {
//   try {
//     const response = await api.post(`${plpsUtilsURL}/save-selected-section/run`, payload);
//     return response.data.response;
//   } catch (error) {
//     console.error("Save Selected Section failed:", error);
//     throw error;
//   }
// };

/**
 * Get Section Data
 */
// export const getPLPSSectionData = async (payload) => {
//   try {
//     const response = await api.post(`${plpsUtilsURL}/get-section-list/run`, payload);
//     return response.data.response;
//   } catch (error) {
//     console.error("Get Section Data failed:", error);
//     throw error;
//   }
// };

/**
 * Save Generated Log
 */
// export const savePLPSGeneratedLog = async (payload) => {
//   try {
//     const response = await api.post(`${plpsUtilsURL}/save-generated-log/run`, payload);
//     return response.data.response;
//   } catch (error) {
//     console.error("Save PLPS Generated Log failed:", error);
//     throw error;
//   }
// };

/**
 * Get Generated Log
 */
// export const getPLPSGeneratedLog = async (payload) => {
//   try {
//     const response = await api.post(`${plpsUtilsURL}/get-log-generated/run`, payload);
//     return response.data.response;
//   } catch (error) {
//     console.error("Get PLPS Generated Log failed:", error);
//     throw error;
//   }
// };

/**
 * Get Context Library
 */
// export const getPLPSContextLib = async (payload, signal) => {
//   try {
//     const response = await api.post(`${plpsUtilsURL}/get-context-lib/run`, payload, { signal });
//     return response.data.response;
//   } catch (error) {
//     if (axios.isCancel?.(error) || error.name === "CanceledError" || err.code === "ERR_CANCELED") {
//       console.warn("PLPS Context Library request aborted");
//       return; // exit silently
//     }
//     console.error("Get PLPS Static Context Library failed:", error);
//     throw error;
//   }
// };
